import { Route, Switch, useRouteMatch } from "react-router";

import TagCategories from "./TagCategories";
import TagCreate from "./TagCreate";
import TagList from "./TagList";

const Tags = (props) => {
    let { path } = useRouteMatch();
    return <Switch>
        <Route path={`${path}/create`}><TagCreate {...props} /></Route>
        {/* Read-only categories with their schema (metaplan A10); before /:id, which is a tag id. */}
        <Route path={`${path}/categories/:id`}><TagCategories /></Route>
        <Route path={`${path}/categories`}><TagCategories /></Route>
        <Route path={`${path}/:id`}><TagList {...props} /></Route>
        <Route path={`${path}`}><TagList {...props} /></Route>
    </Switch>;
}

export default Tags;
